/* sv-password.js - the password teaser (sections/sv-password.liquid).
 * 1. Pause: one button stops every ambient animation (WCAG 2.2.2: motion that runs longer than
 *    5 s must be pausable). Reduced-motion users never see motion (CSS), so the button hides.
 * 2. Countdown: shows "Reopens in 12D 04H 31M" while the editor's launch date is in the future;
 *    hidden when the date is empty, unreadable or past. Refreshes every 30 s.
 * Re-runs on shopify:section:load (theme editor) and sv:password:refresh (tests). */
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  // Offset (ms) of an IANA zone at instant t, e.g. Australia/Melbourne is +11 h in October, +10 h in May.
  const offsetAt = (t, zone) => {
    const p = {};
    for (const { type, value } of new Intl.DateTimeFormat('en-US', { timeZone: zone, hourCycle: 'h23', year: 'numeric',
      month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).formatToParts(new Date(t))) p[type] = +value;
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(t / 1000) * 1000;
  };
  // The editor date is the shop's wall time (data-tz = the shop's IANA zone), converted at that date's
  // own offset so a daylight-saving change before reopening cannot shift it; every visitor counts down
  // to the same instant. A date with its own Z/offset is used as is; an unknown zone falls back to local.
  const target = (raw, zone) => {
    const iso = raw.length === 10 ? `${raw}T00:00` : raw;
    if (/(Z|[+-]\d\d:?\d\d)$/.test(iso)) return Date.parse(iso);
    const m = iso.match(/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)$/);
    if (!m) return NaN;
    const wall = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
    try { let t = wall - offsetAt(wall, zone); t = wall - offsetAt(t, zone); return t; } catch { return Date.parse(iso); }
  };

  const countdown = (el) => {
    const raw = (el.dataset.launch || '').trim();
    const when = raw ? target(raw, el.dataset.tz || 'UTC') : NaN;
    el.dataset.target = Number.isNaN(when) ? '' : String(when);
    const left = Number.isNaN(when) ? -1 : when - Date.now();
    if (left <= 0) { el.hidden = true; el.textContent = ''; return; }
    const m = Math.floor(left / 60e3);
    const d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), min = m % 60;
    el.textContent = `${el.dataset.label || 'Reopens in'} ${d}D ${pad(h)}H ${pad(min)}M`;
    el.hidden = false;
  };

  let timer = 0;
  const init = () => {
    document.querySelectorAll('[data-sv-pw]').forEach((root) => {
      const btn = root.querySelector('.sv-pw__pause');
      if (btn && !btn.dataset.bound) {
        btn.dataset.bound = '1';
        btn.addEventListener('click', () => {
          root.classList.add('is-entered');
          const paused = root.classList.toggle('is-paused');
          btn.setAttribute('aria-pressed', String(paused));
          btn.setAttribute('aria-label', paused ? 'Play motion' : 'Pause motion');
        });
      }
    });
    const tick = () => document.querySelectorAll('.sv-pw__countdown').forEach(countdown);
    tick();
    clearInterval(timer);
    timer = setInterval(tick, 30e3);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('sv:password:refresh', init);
})();
